import React from "react";
import ShowAllTransactionDetails from "@/pages/Sale/Report/ShowAllTransactionDetails";
import HandlingCrispInMobile from "@/components/mobile/HandlingCrispInMobile";

const ReportSale: React.FC = () => (
  <HandlingCrispInMobile>
    <ShowAllTransactionDetails />
  </HandlingCrispInMobile>
);

export default ReportSale;
